import { BrandHealthEntry } from '@blisspointmedia/bpm-types/dist/BrandHealthMetrics';
import { formatNumber } from '@blisspointmedia/bpm-types/dist/formatUtils';

/**
 * Sorts the getBrandHealthInfo rows by metric then date for any interval other than 'day', and
 * formats the moving averages to one decimal place and the sample sizes to whole numbers.
 */
export const formatBrandHealthEntries = (
  entries: BrandHealthEntry[],
  dateInterval: string
): BrandHealthEntry[] => {
  const ordered =
    dateInterval === 'day'
      ? entries
      : [...entries].sort((a, b) => {
          const metricComparison = a.metric.localeCompare(b.metric);
          if (metricComparison === 0) {
            return a.date.localeCompare(b.date);
          }
          return metricComparison;
        });

  return ordered.map(entry => ({
    metric: entry.metric,
    date: entry.date,
    focal_ma: formatNumber(parseFloat(String(entry.focal_ma)), 1),
    focal_sample_size: formatNumber(parseFloat(entry.focal_sample_size), 0),
    non_focal_ma: formatNumber(parseFloat(String(entry.non_focal_ma)), 1),
    non_focal_sample_size: formatNumber(parseFloat(entry.non_focal_sample_size), 0)
  }));
};
